const state = {
    archived:null,
    supports:null,
};

const getters = {
    getArchived: state => state.archived,
    getSupports: state => state.supports,
};

const actions = {
    setArchived: (store, payload) => store.commit('ARCHIVED_SET', payload),
    setSupports: (store, payload) => store.commit("SUPPORTS_SET",payload),
};

const mutations = {
    ARCHIVED_SET: (state, payload) => state.archived = payload,
    SUPPORTS_SET: (state, payload) => state.supports = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
